import { type ButtonProps as MuiButtonProps } from "@mui/material/Button";
import { TooltipProps } from "@mui/material/Tooltip";
import BaseButton from "../BaseButton";
import TooltipButton from "../TooltipButton";

type ButtonCustomColorVariant = "warning" | "error";

export interface ButtonProps extends MuiButtonProps {
  loading?: boolean;
  customColorVariant?: ButtonCustomColorVariant;
  tooltip?: string;
  tooltipPlacement?: TooltipProps["placement"];
}

export const Button = ({
  tooltip,
  tooltipPlacement,
  ...props
}: ButtonProps) => {
  if (tooltip) {
    return (
      <TooltipButton
        tooltip={tooltip}
        tooltipPlacement={tooltipPlacement}
        {...props}
      />
    );
  }

  return <BaseButton {...props} />;
};

export default Button;
